const FromArr = [
  {
    modelvalue: "",
    title: "经销商名称：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 200,
    height: 32,
    disabled: false,
    marginLeft: 50,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  
  {
    modelvalue: "",
    title: "产品线：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 210,
    height: 32,
    disabled: false,
    marginLeft: 120,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: []
  },
  {
    modelvalue: "",
    title: "指定配送商/采购代理：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 190,
    height: 32,
    disabled: false,
    marginLeft: 90,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    modelvalue: "",
    title: "下级经销商：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 200,
    height: 32,
    disabled: false,
    marginLeft: 50,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    modelvalue: "",
    title: "医院名称：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 200,
    height: 32,
    disabled: false,
    marginLeft: 105,
    marginTop: 10,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  // {
  //   modelvalue: '1',
  //   title: "是否有终端医院发票：",
  //   inputtype: "select",
  //   inputflag: true,
  //   fontSize: 14,
  //   color: "#333333",
  //   lableheight: 20,
  //   X: false,
  //   types: "",
  //   placeholder: "请选择",
  //   width: 200,
  //   height: 32,
  //   disabled: false,
  //   marginLeft: 25,
  //   marginTop: 30,
  //   displayVal: "inline-block",
  //   fontWeightVal: 500,
  //   options: [
  //     {
  //       key: "1",
  //       value: "是",
  //     },
  //     {
  //       key: "2",
  //       value: "否",
  //     },
  //   ]
  // },
  {
    title: "审核日期：",
    StartTime: '',
    EndTime: '',
    inputtype: "dateSection",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    heightLeft: 32,
    heightRight: 32,
    widthLeft: 150,
    widthRight: 150,
    disabled: false,
    marginLeft: 88,
    marginTop: 14,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    title: "创建日期：",
    StartTime: '',
    EndTime: '',
    inputtype: "dateSection",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    heightLeft: 32,
    heightRight: 32,
    widthLeft: 150,
    widthRight: 150,
    disabled: false,
    marginLeft: 55,
    marginTop: 14,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    modelvalue: "",
    title: "申请单号：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 200,
    height: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 10,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    modelvalue: "",
    title: "状态：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 330,
    height: 32,
    disabled: false,
    marginLeft: 80,
    marginTop: 10,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: []
  },
];
export default FromArr;
